import State from 'tools/state';
import Utils from 'tools/utils';
import ContextMenuConstants from 'controls/contextMenuConstants';

export default function ContextMenu(config) {
	Utils.apply(this, config);
	this.initComponent();
}

ContextMenu.prototype = {
	/**
	 * @config {jQuery} element The jQuery element that contains the menu
	 */
	element: $('.cw_multi_content'),
	/**
	 * Main init class
	 */
	initComponent: function () {
		this.updateOnRoles();
	},

	updateOnRoles: function () {
		// top menu items
		if (!State.mainApp.session.hasRole('SERVICE_CREATE')) {
			$('#cw_multi_service').off().remove();
		}
		if (!State.mainApp.session.hasRole('ACCOUNT_CREATE')) {
			$('#cw_multi_account').off().remove();
		}
		if (!State.mainApp.session.hasRole('USER_CREATE')) {
			$('#cw_multi_user').off().remove();
		}
		if (!State.mainApp.session.hasRole('TEAM_CREATE')) {
			$('#cw_multi_team').off().remove();
		}
		if (!State.mainApp.session.hasRole('ASSET_CREATE')) {
			$('#cw_multi_asset').off().remove();
		}
		if (!State.mainApp.session.hasRole('AUTHENTICATION_CREATE')) {
			$('#cw_multi_auth').off().remove();
		}
		if (!State.mainApp.session.hasRole('SERVICEBOARD_CREATE')) {
			$('#cw_multi_dashboard').off().remove();
		}
		if (!State.mainApp.session.hasRole('SLA_CREATE')) {
			$('#cw_multi_sla').off().remove();
		}
		if (!State.mainApp.session.hasRole('REPORT_CREATE')) {
			$('#cw_multi_report').off().remove();
		}
		if (!State.mainApp.session.hasRole('GROUP_CREATE')) {
			$('#cw_multi_asset_group').off().remove();
		}
		if (!State.mainApp.session.hasRole('CALENDAR_CREATE')) {
			$('#cw_multi_calendar').off().remove();
		}
		if (!State.mainApp.session.hasRole('APPLICATION_CREATE')) {
			$('#cw_multi_application').off().remove();
		}
		if (!State.mainApp.session.hasRole('AUTOMATION_CREATE')) {
			$('#cw_multi_automation').off().remove();
		}
		if (!State.mainApp.session.hasRole('HEALTHFILTER_CREATE')) {
			$('#cw_multi_filter').off().remove();
		}
		if (!State.mainApp.session.hasRole('USER_CATEGORY_CREATE')) {
			$('#cw_multi_role').off().remove();
		}
		if (!State.mainApp.session.hasRole('COST_CREATE')) {
			$('#cw_multi_cost').off().remove();
		}
	},
};
